module.exports = "/_next/static/images/87dfa76657df8c4d20973e290cba5464-push-notification.svg.webp";